export function saveBestScore(levelName: string, score: number) {
  const key = `bestScore_level_${levelName}`;
  const currentBestScore = localStorage.getItem(key);
  if (currentBestScore === null || score > parseInt(currentBestScore)) {
    console.log(`storing ${key}`);
    localStorage.setItem(key, score.toString());
  }
}

export function getBestScore(levelName: string): number | null {
  const key = `bestScore_level_${levelName}`;
  const storedScore = localStorage.getItem(key);
  console.log(`getting ${key}`);
  return storedScore ? parseInt(storedScore) : null;
}

export function clearBestScores() {
  const keysToRemove: string[] = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key.startsWith("bestScore_level_")) {
      keysToRemove.push(key);
    }
  }
  keysToRemove.forEach(key => localStorage.removeItem(key));
}